"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default(_ref) {
  var compilerService = _ref.compilerService;
  return {
    name: 'xargs',
    synopsis: 'xargs [COMMAND] ...[LIST]',
    description: 'Distribute list items to a command',
    execute: function execute(_ref2) {
      var _ref3 = _toArray(_ref2),
          source = _ref3[0],
          list = _ref3.slice(1);

      var command = compilerService.compile(source);
      return Promise.all(list.map( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(arg) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", command(arg, {}));

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }()));
    }
  };
};

exports.default = _default;